import { createContext } from 'react';

const NodeContext = createContext<{ nodeNameArray: { id: string; name: string }[] }>({
  nodeNameArray: [],
});
export default NodeContext;
